import { Region } from '../../shared/models';

export class ChatMessage {
    id: number;
    type: string;
    image?: string;
    timestamp: string;
    text: string;
    region: Region;
    user: string;
    name: string;

    constructor(obj: any) {
        Object.assign(this, obj);
        this.id =  obj.order || null;
        this.user = obj.name || null;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/chat/models/chat-message.ts